import { render, staticRenderFns } from "./DSAgreementCard.vue?vue&type=template&id=1601a65c&"
import script from "./DSAgreementCard.vue?vue&type=script&lang=js&"
export * from "./DSAgreementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports